/**
 * Matches backend mutation. QuickSuiteChatInput only accepts 'username'.
 * Response can include AgentArn when backend returns it.
 */
export const GET_QUICK_SUITE_CHAT_URL = `
  mutation GetQuickSuiteChatUrl($username: String!) {
    getQuickSuiteChatUrl(quickSuiteChatInput: { username: $username }) {
      data {
        EmbedUrl
        RequestId
        Status
      }
      error {
        code
        message
        statusCode
      }
    }
  }
`
